import { twMerge } from 'utilities/src/twMerge';
import React from 'react';
import useCardTheme from './themes';

type CardMinutesReadProps = {
  readingTime: number;
  classes?: string;
};

function CardMinutesRead({ readingTime, classes }: CardMinutesReadProps) {
  const { minutesReadClasses, minutesReadVariantClasses } = useCardTheme();

  return <p className={twMerge(minutesReadClasses, minutesReadVariantClasses, classes)}>{readingTime} min read</p>;
}

export default CardMinutesRead;
